<template>
  <v-card>
    <v-card-title class="primary accent--text">
      Payment Information
    </v-card-title>
    <v-card-text>
      <v-row>

        <v-col cols="12" md="4">
          <v-row>
            <v-col
              cols="6"
              class="grey--text"
            >
              Amount
            </v-col>
            <v-col cols="6">
              {{ getAmount() }}
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="6"
              class="grey--text"
            >
              Fee
            </v-col>
            <v-col cols="6">
              {{ getFee() }}

              <fee-info-icon
                :fees="getFees()"
                :currency="invoice.currency"
              />

            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="6"
              class="grey--text"
            >
              Net
            </v-col>
            <v-col cols="6">
              {{ getNet() }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="4">
          <info-list
            :list="paymentDetails()"
          />
        </v-col>
        <v-col cols="12" md="4">
          <info-list
            :list="paymentMethod()"
          />
        </v-col>
      </v-row>

    </v-card-text>
  </v-card>
</template>
<script>
import InfoList from "../Common/InfoList"
import FeeInfoIcon from '../Fee/FeeInfoIcon'
import { get } from 'lodash'
import { formatMoney } from "../../services/util.service"

export default {
  components: { InfoList, FeeInfoIcon },
  props: {
    invoice: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    getFees() {
      return get(this.invoice, 'payment_intent.charges.data[0].balance_transaction.fee_details', []) || []
    },
    getAmount() {
      const amount = get(this.invoice, 'payment_intent.charges.data[0].balance_transaction.amount', 0)
      const currency = this.invoice.currency

      return formatMoney({ amount, currency })
    },
    getFee() {
      const amount = get(this.invoice, 'payment_intent.charges.data[0].balance_transaction.fee', 0)
      const currency = this.invoice.currency

      return formatMoney({ amount, currency })
    },
    getNet() {
      const amount = get(this.invoice, 'payment_intent.charges.data[0].balance_transaction.net', 0)
      const currency = this.invoice.currency

      return formatMoney({ amount, currency })
    },
    paymentMethod() {
      return [
        {
          label: 'Number',
          value: '****' + get(this.invoice, 'payment_intent.charges.data[0].payment_method_details.card.last4', ''),
        },
        {
          label: 'Expires',
          value: get(this.invoice, 'payment_intent.charges.data[0].payment_method_details.card.exp_month')
            + ' / '
            + get(this.invoice, 'payment_intent.charges.data[0].payment_method_details.card.exp_year')
        },
        {
          label: 'Type',
          value: get(this.invoice, 'payment_intent.charges.data[0].payment_method_details.card.brand'),
        },
        {
          label: 'Origin',
          value: get(this.invoice, 'payment_intent.charges.data[0].payment_method_details.card.country'),
        }
      ]
    },
    paymentDetails() {
      return [
        {
          label: 'Receipt Number',
          value: get(this.invoice, 'payment_intent.charges.data[0].receipt_number'),
        },
        {
          label: 'Status',
          value: get(this.invoice, 'status', ''),
        },
        {
          label: 'Description',
          value: get(this.invoice, 'payment_intent.description'),
        }
      ]
    }
  }
}
</script>
